/* ============================================================
   Nordstealth — KI-Hinweis an Bildern
   ------------------------------------------------------------
   Setzt an jedes INHALTSBILD unten rechts ein kleines "i". Antippen
   oder Ueberfahren zeigt: "Dieses Bild entstand mit Unterstuetzung
   durch KI."

   WAS EIN INHALTSBILD IST
   Alles, was der Kunde als Foto liest: Produktaufnahmen, Galerie,
   Sektionsbilder, Bild-mit-Text, Szenen.

   WAS AUSGENOMMEN IST (und warum)
     Kundenavatare      keine erzeugten Fotos im Sinn der Kennzeichnung,
                        ausserdem 40px klein
     Symbole und Logos  SVG, Zahlungsabzeichen, Kopfzeilen-Logo
     Vorschaubilder     Galerie-Thumbnails und Bundle-Bildchen: dort saessen
                        acht "i" nebeneinander, der Hinweis steht am grossen
                        Bild derselben Aufnahme
     Videos             tragen kein img, werden also gar nicht erst gefunden
     Winzige Bilder     alles unter 120px Kantenlaenge

   AUFBAU
   Der Knopf braucht einen positionierten Halter. Genommen wird der naechste
   Vorfahr, der das Bild bereits umschliesst (figure, .media, .card__media
   und so weiter). Steht der auf position: static, bekommt er die Klasse
   .ns-ki-halter, die ihn auf relative setzt. Kein Umbauen des Markups:
   ein zusaetzliches Wrapper-Element wuerde Raster und Slider zerreissen.

   Der Beobachter faengt Bilder nach, die Shopify erst spaeter nachlaedt
   (Variantenwechsel, Warenkorb-Neuzeichnung, Slider-Kopien).
   ============================================================ */
(function () {
  'use strict';

  var TEXT = 'Dieses Bild entstand mit Unterstützung durch KI.';
  var MIN = 120; // Kantenlaenge in px, darunter gilt ein Bild als Symbol

  /* ------------------------------------------------------------
     AUSNAHMEN: echte Aufnahmen, die KEINEN Hinweis tragen.

     Hier stehen Dateinamen OHNE Endung. Shopify haengt je nach Groesse
     Zusaetze an (48848_600x.webp), deshalb wird auf den Namensanfang
     geprueft, nicht auf Gleichheit.

     Neue Ausnahme eintragen: Dateinamen in die Liste, fertig. Der Name
     steht im Adminbereich unter Inhalte -> Dateien, oder im Browser per
     Rechtsklick auf das Bild.
     ------------------------------------------------------------ */
  var OHNE_HINWEIS = [
    'P1',          // Hemd mit Krawatte, Handy wird gezogen
    '48848',       // Studioaufnahme schwarz, freigestellt
    '84894',       // Studioaufnahme hellbraun, freigestellt
    '884896',      // Studioaufnahme braun, freigestellt
    '5581',        // Studioaufnahme hellbraun, zweite Fassung
    '5848479',     // Detail: Kante, Naht und Reissverschluss
    '21518',       // Hemd mit Krawatte, zweite Fassung mit weniger Falten
  ];

  /* Bewusst NICHT ausgenommen, obwohl sie Studioaufnahmen enthalten:
       88888   Produktmasse-Grafik
       44184   Infografik "Durchdacht bis zur letzten Naht"
     Beide sind zusammengesetzte Grafiken, keine reinen Fotos. Sie tragen
     den Hinweis, so entschieden am 08.08.2026.

     44184.webp hat am 12.08.2026 die Vorgaengerin 511515.webp auf
     Galerieposition 8 ersetzt. Deren Text behauptete "Premium-Kunstleder"
     und "Schutz vor Witterung" und siezte den Kunden. Steht 511515 einmal
     wieder im Shop, gehoert es hier ebenso NICHT in die Ausnahmen. */

  // Eigene Aufnahmen des Haendlers heissen P1, P2, P3 und so weiter. Die
  // ganze Reihe ist ausgenommen, damit nach dem naechsten Hochladen nicht
  // wieder ein Hinweis auf einem echten Foto steht.
  var EIGENE_REIHE = /^p\d+(_[0-9a-z]+)?\.[a-z0-9]+$/;

  /* Die Ausdruecke EINMAL bauen, nicht bei jedem Bild.
     Vorher entstanden sie in der Schleife: 6 Durchgaenge x 122 Bilder x 7
     Ausdruecke = 5124 RegExp-Konstruktionen je Seitenaufbau. Gemessen 2,5 bis
     15,8 ms bei vierfach gebremster CPU. Kein /g-Flag, also gibt es auch kein
     lastIndex, das zwischen Aufrufen nachwirken koennte. */
  var AUSNAHME_RE = (function () {
    var raus = [];
    for (var i = 0; i < OHNE_HINWEIS.length; i++) {
      var basis = OHNE_HINWEIS[i].toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      // basis, danach optional _600x oder aehnlich, dann die Endung
      raus.push(new RegExp('^' + basis + '(_[0-9a-z]+)?\\.[a-z0-9]+$'));
    }
    return raus;
  })();

  function istAusnahme(quelle) {
    var name = (quelle.split('?')[0].split('/').pop() || '').toLowerCase();
    if (EIGENE_REIHE.test(name)) return true;
    for (var i = 0; i < AUSNAHME_RE.length; i++) {
      if (AUSNAHME_RE[i].test(name)) return true;
    }
    return false;
  }

  // Container, in denen grundsaetzlich kein Hinweis stehen soll.
  var VERBOTEN = [
    '.header', '.header-wrapper', '.footer', '.menu-drawer',
    '.thumbnail-list', '.product__media-thumbnail', '.thumbnail',
    '.slider__dots', '.payment-badges', '.list-payment',
    '.ns-customer-info', '.ns-proof', '.ns-review-card',
    '.quantity-break__image', '.quantity-break__variant-image',
    '.product-upsell', '.upsell', '.cart-item__image-container',
    '.ns-agg', '.ns-tp', '.complementary-products',
    '.ns-popup', '.ns-popup-overlay',
  ].join(',');

  // Einzelne Bilder, die nie gekennzeichnet werden.
  var VERBOTEN_BILD = [
    '.ns-avatar-img', '.header__heading-logo', '.footer__logo',
    '.ns-usp__ic img', '.ns-trust-icon', '.icon',
  ].join(',');

  /* ------------------------------------------------------------
     LESEN UND SCHREIBEN SIND GETRENNT (12.08.2026)

     Vorher lief pro Bild: Rechteck lesen, Klassen schreiben, naechstes Bild
     Rechteck lesen. Jede Schreiboperation macht das Layout ungueltig, also
     musste der Browser es fuer jedes weitere Rechteck neu berechnen —
     erzwungener dynamischer Umbruch. Gemessen 87 bis 109 ms je Seitenaufbau
     bei vierfach gebremster CPU, aus einer 147-ms-Aufgabe.

     Jetzt zwei Phasen: pruefen() liest nur und sammelt Auftraege, setzen()
     schreibt nur. Danach 11 ms. Das Rechteck wird dabei EINMAL gelesen und
     an istInhaltsbild und halterFuer weitergegeben, statt dreimal.

     Auswahl, Reihenfolge, Ausnahmeliste und die 120-px-Grenze sind
     unveraendert. Gegengeprueft: 10 Hinweise, 10 Halter, 8 Galerie-Halter,
     0 Klein-Halter — Bilddatei, Halterklassen und Blasentext Zeichen fuer
     Zeichen gleich, inklusive Reihenfolge.
     ------------------------------------------------------------ */
  function istInhaltsbild(img, r) {
    if (!img || img.dataset.nsKi) return false;
    var quelle = img.currentSrc || img.src || '';
    if (!quelle || quelle.indexOf('data:') === 0) return false;
    if (/\.svg(\?|$)/i.test(quelle)) return false;
    if (istAusnahme(quelle)) return false;
    if (img.closest(VERBOTEN)) return false;
    if (img.matches(VERBOTEN_BILD)) return false;

    // Noch nicht gelayoutet: spaeter erneut versuchen.
    if (r.width === 0 && r.height === 0) return false;
    if (r.width < MIN || r.height < MIN) return false;
    return true;
  }

  function halterFuer(img, b) {
    // Der naechste Vorfahr, der das Bild vollstaendig umschliesst und nicht
    // die halbe Seite gross ist.
    var kandidat = img.closest(
      'figure, picture, .media, .card__media, .product__media, .banner__media,' +
      ' .image-with-text__media, .ns-kern__shot, .ns-an__media, .ns-mat__media,' +
      ' .ns-hero__media, .ns-sz__media, .global-media-settings'
    );
    if (kandidat && kandidat.tagName === 'PICTURE') kandidat = kandidat.parentElement;
    if (!kandidat) kandidat = img.parentElement;
    if (!kandidat) return null;

    // Der Halter darf nicht wesentlich groesser sein als das Bild, sonst
    // haengt das "i" irgendwo im Layout statt in der Bildecke.
    // b kommt von aussen — das Rechteck des Bildes wurde in pruefen() schon
    // gelesen und wird nicht ein zweites Mal geholt.
    var h = kandidat.getBoundingClientRect();
    if (h.height > b.height * 1.6 + 40 || h.width > b.width * 1.6 + 40) {
      return img.parentElement || kandidat;
    }
    return kandidat;
  }

  // NUR LESEN. Gibt einen Auftrag zurueck oder null.
  function pruefen(img) {
    if (!img || img.dataset.nsKi) return null;
    var r = img.getBoundingClientRect();
    if (!istInhaltsbild(img, r)) return null;
    var halter = halterFuer(img, r);
    if (!halter) return null;
    return {
      img: img,
      halter: halter,
      // closest() geht den Baum hoch und erzwingt kein Layout — steht
      // trotzdem hier, damit die Schreibphase voellig lesefrei bleibt.
      galerie: !!halter.closest('.product__media-list, media-gallery'),
      klein: r.width < 200 || r.height < 200,
    };
  }

  // NUR SCHREIBEN.
  function setzen(auftrag) {
    var img = auftrag.img;
    var halter = auftrag.halter;
    // Diese Sperre MUSS in der Schreibphase bleiben: zwei Bilder koennen im
    // selben Durchgang auf denselben Halter zeigen, und der zweite darf kein
    // zweites "i" anhaengen. Ein querySelector erzwingt kein Layout.
    if (halter.querySelector(':scope > .ns-ki')) { img.dataset.nsKi = '1'; return; }

    img.dataset.nsKi = '1';
    halter.classList.add('ns-ki-halter');
    if (auftrag.galerie) halter.classList.add('ns-ki-halter--galerie');
    if (auftrag.klein) halter.classList.add('ns-ki-halter--klein');

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'ns-ki';
    knopf.setAttribute('aria-expanded', 'false');
    knopf.setAttribute('aria-label', 'Hinweis zu diesem Bild');
    knopf.textContent = 'i';

    var blase = document.createElement('span');
    blase.className = 'ns-ki__blase';
    blase.setAttribute('role', 'tooltip');
    blase.textContent = TEXT;

    knopf.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var offen = knopf.getAttribute('aria-expanded') === 'true';
      zuklappen();
      if (!offen) aufklappen(knopf);
    });

    halter.appendChild(knopf);
    halter.appendChild(blase);
  }

  /* ------------------------------------------------------------
     Auf- und Zuklappen an einer Stelle.

     Die Blase schliesst auf drei Wegen:
       1. Beruehrung woanders (click UND touchstart — auf dem Handy
          kommt click erst nach dem Loslassen und bleibt aus, wenn der
          Finger dabei ein Stueck wandert)
       2. Escape
       3. von selbst nach 5 Sekunden

     Der Zeitgeber haengt am Modul, nicht am Knopf: es ist ohnehin
     immer nur eine Blase offen, und so kann eine zweite Blase den
     Zeitgeber der ersten nicht ueberdauern.
     ------------------------------------------------------------ */
  var ZEIT = 5000;
  var uhr = 0;

  function aufklappen(knopf) {
    knopf.setAttribute('aria-expanded', 'true');
    if (uhr) clearTimeout(uhr);
    uhr = setTimeout(zuklappen, ZEIT);
  }

  function zuklappen() {
    if (uhr) { clearTimeout(uhr); uhr = 0; }
    var offene = document.querySelectorAll('.ns-ki[aria-expanded="true"]');
    for (var i = 0; i < offene.length; i++) offene[i].setAttribute('aria-expanded', 'false');
  }

  function durchgang(wurzel) {
    var bilder = (wurzel || document).querySelectorAll('img');
    // Erst alles lesen …
    var auftraege = [];
    for (var i = 0; i < bilder.length; i++) {
      var a = pruefen(bilder[i]);
      if (a) auftraege.push(a);
    }
    // … dann alles schreiben. Die Reihenfolge bleibt die des Dokuments.
    for (var j = 0; j < auftraege.length; j++) setzen(auftraege[j]);
  }

  function start() {
    durchgang(document);

    // Ein zweiter Durchgang, wenn Bilder fertig geladen und vermessen sind:
    // vorher liefert getBoundingClientRect bei lazy-Bildern 0.
    window.addEventListener('load', function () { setTimeout(function () { durchgang(document); }, 300); });
    setTimeout(function () { durchgang(document); }, 1200);

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.ns-ki')) zuklappen();
    });
    // Auf dem Handy zaehlt die Beruehrung, nicht erst der Klick.
    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.ns-ki')) zuklappen();
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') zuklappen();
    });
    // Wer weiterscrollt, hat die Blase gelesen oder will sie nicht.
    window.addEventListener('scroll', function () {
      if (document.querySelector('.ns-ki[aria-expanded="true"]')) zuklappen();
    }, { passive: true });

    if (!('MutationObserver' in window)) return;
    var wartet = 0;
    new MutationObserver(function () {
      if (wartet) return;
      wartet = setTimeout(function () { wartet = 0; durchgang(document); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
